import { useState } from 'react';
import cN from 'classnames';
import './index.less';

interface IProps {
  title: string;
}

const ProductTitle = ({ title }: IProps) => {
  const [expanded, setExpanded] = useState<boolean>(false);

  return (
    <div
      className={cN('product-details-title', {
        collapsed: !expanded,
      })}
      onClick={() => setExpanded(!expanded)}
    >
      {title}
    </div>
  );
};

export default ProductTitle;
